import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {PaymentOptionsData} from "../../../../shared/data/recharges-response-data";

import Inputmask from "inputmask/dist/inputmask/inputmask.date.extensions.js";
import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {FormUtility} from "../../../../shared/utility/form-utility";
import {FormInputUtility} from "../../../../shared/utility/form-input-utility";

@Component({
    selector: 'blik-method',
    templateUrl: './blik-method.component.html',
    standalone: false
})
export class BlikMethodComponent implements OnInit, AfterViewInit, OnDestroy {
  @Output() bankSelectedEvent = new EventEmitter<PaymentOptionsData>();
  @Input() paymentForm: UntypedFormGroup;

  @ViewChild('blikInput', { static: true }) blikInput: ElementRef;

  readonly BLIK_MASK = '999 999';

  constructor() { }

  ngOnInit() {
    this.paymentForm.addControl('blik', new UntypedFormControl('', [Validators.required, FormUtility.validateBlik]));
  }

  ngAfterViewInit(): void {
    Inputmask({mask: this.BLIK_MASK, showMaskOnHover: false})
      .mask(this.blikInput.nativeElement);
  }

  ngOnDestroy(): void {
    this.paymentForm.removeControl('blik');
  }

  isBlikInvalid() {
    return FormInputUtility.isInputInvalid(this.paymentForm.get('blik'));
  }

  getBlikErrorMsg() {
    return FormInputUtility.getErrorMsg(this.paymentForm.get('blik'), FormInputUtility.BLIK_ERROR_MSG);
  }

}
